import { useCreation } from 'ahooks';
import React, { useMemo } from 'react';
import { useScale } from '@/framework';
import { useLoadingState } from '@/framework/core/states/loading-state';
import { TableLoadingParams, TableNode } from '@/layers/table-layer/view/table-layer';
import { ITableLayer, ITableLayerProps } from '@/version-types';
import LayerLoading from './layer-loading';

const TableLayerLoadingItemNode: React.FC<{ layer: ITableLayer }> = ({ layer }) => {
    const loadingFontFamilyList = useLoadingState()((s) => s.loadingMap[layer.id] ?? null) as string[] | null;

    const scale = useScale();

    const cellIds = useMemo(() => {
        if (!layer) return [];
        const cellIds: string[] = [];
        const targetStyleIds = Object.entries(layer.data.styles)
            .filter(([_, style]) => style.fontFamily && loadingFontFamilyList?.includes(style.fontFamily))
            .map(([id]) => id);
        layer.data.cells.flat().forEach((cell) => {
            if (!cell?.styleIds.length) return;
            if (!cell.content) return;
            const thisEffectiveStyleId = cell.styleIds.findLast((id) => layer.data.styles[id].fontFamily);
            if (thisEffectiveStyleId && targetStyleIds.includes(thisEffectiveStyleId)) {
                cellIds.push(cell.__renderId);
            }
        });
        return cellIds;
    }, [loadingFontFamilyList]);

    const tableLoadingParams: TableLoadingParams = useCreation(
        () => ({
            onlyShowLoading: true,
            loadingNode: (cid) => cellIds.includes(cid) && <LayerLoading scale={1 / scale} />,
        }),
        [cellIds],
    );

    if (!layer) return null;

    // console.time('===render TableLayerLoadingItemNode');

    const res = (
        <TableNode
            tableLayerWidth={layer.width}
            tableLayerData={layer.data as ITableLayerProps}
            fontFamilyMap={layer.__runtime?.fontFamilyMap ?? {}}
            tableLoadingParams={tableLoadingParams}
        />
    );

    // console.timeEnd('===render TableLayerLoadingItemNode');

    return res;
};

TableLayerLoadingItemNode.displayName = 'TableLayerLoadingItemNode';

export default TableLayerLoadingItemNode;
